export const expandDayOfWeek = (shortDay: string) => {
   switch(shortDay) {
      case 'Mon':
         return 'Monday'
      case 'Tue':
         return 'Tuesday'
      case 'Wed':
         return 'Wednesday'
      case 'Thu':
         return 'Thursday'
      case 'Fri':
         return 'Friday'
      case 'Sat':
         return 'Saturday'
      case 'Sun':
         return 'Sunday'
      case 'WeekendDay':
         return 'Weekend Day' 
      case 'Day':
         return 'Day'
      case 'Weekday':
         return 'Weekday'
   }
}

export const expandMonthNumber = (monthNumber: number) => {
   const monthsArray = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
   ];

   return monthsArray[monthNumber-1];
}